import { IntakeCardProps } from './IntakeCard'
import { IntakeField } from './_styles'

export const Duration = ({ intake }: IntakeCardProps) => {
  const { durationFullTime, durationPartTime, durationType } = intake

  if ((!durationFullTime && !durationPartTime) || !durationType) return null

  let str = ''

  if (durationFullTime) str += `${durationFullTime} ${durationType} (Full Time)`
  if (durationFullTime && durationPartTime) {
    str += `, `
  }
  if (durationPartTime) str += `${durationPartTime} ${durationType} (Part Time)`

  return (
    <IntakeField>
      <span>Duration:</span> {str}
    </IntakeField>
  )
}
